// Working window — mirrors BOOKING_WINDOW in backend/server.py. ONE place on
// the client so it can become a trainer setting later.
export const BOOKING_WINDOW = {
  earliestStartMin: 6 * 60, // 06:00
  latestEndMin: 22 * 60, // 22:00
  message: "Classes can be booked between 6:00 am and 10:00 pm.",
};

export const WINDOW_START_HOUR = BOOKING_WINDOW.earliestStartMin / 60;
export const WINDOW_END_HOUR = BOOKING_WINDOW.latestEndMin / 60;

// 6 am … 9 pm. Midnight is never offered as a start.
export const HOUR_CHOICES = Array.from(
  { length: WINDOW_END_HOUR - WINDOW_START_HOUR },
  (_, i) => WINDOW_START_HOUR + i
);
export const MINUTE_CHOICES = [0, 15, 30, 45];

export function hourLabel(h) {
  const suffix = h < 12 ? "am" : "pm";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12} ${suffix}`;
}

export function parseTime(timeStr) {
  const [hh, mm] = String(timeStr || "")
    .split(":")
    .map((v) => parseInt(v, 10));
  if (Number.isNaN(hh)) return { hour: WINDOW_START_HOUR, minute: 0 };
  return { hour: hh, minute: Number.isNaN(mm) ? 0 : mm };
}

export const toTimeStr = (hour, minute) =>
  `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;

export function startMinutes(timeStr) {
  const { hour, minute } = parseTime(timeStr);
  return hour * 60 + minute;
}

export function isOutsideWindow(timeStr, durationMin = 60) {
  const start = startMinutes(timeStr);
  return (
    start < BOOKING_WINDOW.earliestStartMin ||
    start + Number(durationMin || 60) > BOOKING_WINDOW.latestEndMin
  );
}

// True when a session row (from the API) sits outside the window.
export function sessionOutsideWindow(session) {
  if (!session?.starts_at) return false;
  const d = new Date(session.starts_at);
  const start = d.getHours() * 60 + d.getMinutes();
  return (
    start < BOOKING_WINDOW.earliestStartMin ||
    start + Number(session.duration_min || 60) > BOOKING_WINDOW.latestEndMin
  );
}

export function fmtTimeWords(timeStr) {
  const { hour, minute } = parseTime(timeStr);
  const suffix = hour < 12 ? "am" : "pm";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${String(minute).padStart(2, "0")} ${suffix}`;
}

// "Monday 12 Oct, 12:00 pm"
export function fmtChoiceWords(dateIso, timeStr) {
  if (!dateIso) return fmtTimeWords(timeStr);
  const { hour, minute } = parseTime(timeStr);
  const [y, m, d] = dateIso.split("-").map((v) => parseInt(v, 10));
  const date = new Date(y, (m || 1) - 1, d || 1, hour, minute);
  const day = date.toLocaleDateString("en-AU", {
    weekday: "long",
    day: "numeric",
    month: "short",
  });
  return `${day}, ${fmtTimeWords(timeStr)}`;
}
